import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { Organ } from "@models";

@Injectable({
  providedIn: 'root'
})
export class OrganService {

  constructor(private http: HttpClient) {
  }

  getOriginatorOrgans(): Observable<Organ[]> {
    return this.http.get<Organ[]>(`${ environment.T16_VALIDATION_API_URL }/Request/GetOrganEsal`);
  }
}
